<template>
  <div class="car-service-groups">
    <div
      class="car-service-group"
      v-for="(serviceGroup, index) in serviceGroups"
      :key="index"
      :class="{'car-collapse': serviceGroup.collapse, 'car-expand': !serviceGroup.collapse}"
    >
      <div class="car-service-group-label" @click="toggleServiceGroup(serviceGroup)">
        <span class="car-text">
        {{ serviceGroup | optionTranslate }}
        </span>
        <span class="car-icon"></span>
      </div>

      <div class="car-service-group-content">
        <div class="car-items">
          <div class="car-item"
               :data-js="service.id"
               v-for="(service, serviceIndex) in serviceGroup.services"
               :key="serviceIndex">
            <checkbox :label="service | optionTranslate" :is-selected="!!isServiceSelected(service)" :class="{'car-selected': isServiceSelected(service)}" @onClick="toggleService(service)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash';
import { EventBus } from '@/util/event-bus.js';
import Checkbox from '@/components/Checkbox';

export default {
  name: 'ServiceGroups',
  props: {
    serviceGroups: {
      required: 'required'
    },
    maintenance: {
      required: 'required'
    }
  },
  data: function () {
    return {
      lastService: null
    }
  },
  components: {
    Checkbox
  },
  methods: {
    toggleServiceGroup: function(serviceGroup) {
      this.$set(serviceGroup, 'collapse', !serviceGroup.collapse);
    },
    close: function(cancel) {
      if (cancel) this.removeService(this.lastService);
      this.maintenance.show = false;
      this.maintenance.service = null;
      this.clearMaintenancePositions([]);
    },
    isServiceSelected(service) {
      return find(this.selectedServices, { externalId: service.externalId });
    },
    addService(service) {
      this.$store.dispatch('vehicleServices/addService', service);
    },
    removeService(service) {
      this.$store.dispatch('vehicleServices/removeService', service);
    },
    toggleService(service) {
      if (this.isServiceSelected(service)) {
        this.removeService(service);
      } else {
        this.lastService = service;
        if (service.type === 'MAINTENANCE') {
          this.maintenance.show = true;
          this.maintenance.loading = true;
          this.maintenance.requestError = false;
          this.maintenance.service = service;
          this.$store.dispatch('vehicleServices/getMaintenancePositions', service)
            .catch((err) => {
              this.maintenance.requestError = true;
              EventBus.$emit('InteractiveErrorToasterEvent', this.$t('vinIdentification.errors.requestError'))
              return Promise.reject(new Error(err));
            })
            .finally(() => {
              this.maintenance.loading = false;
            })
        } else {
          this.addService(service);
        }
      }
    },
    goToVehicleSelection() {
      this.$router.push({ name: 'CatalogIdentification' });
    }
  },
  computed: {
    serviceCategories() {
      return this.$store.getters['vehicleServices/topServiceCategoryGroup'].serviceCategories;
    },
    selectedServices() {
      return this.$store.getters['vehicleServices/selectedServices'];
    }
  }
}
</script>
